<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <ShopsFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter"
        ></ShopsFilterForm>
        <TopShopsListPanel
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
        ></TopShopsListPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredShops && filteredShops.length == 0 ? 'empty' : 'filled',
          ]"
        >
          <ShopsTable
            :shops="filteredShops"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(43) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updateShopsList"
          ></ShopsTable>
          <EmptyTableMessage
            v-if="filteredShops && filteredShops.length == 0 && !isLoading"
          >
            <template #text>
              Примените другой фильтр или создайте первый магазин. <br />
              Для этого кликните на кнопку "Создать магазин".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updateShopsList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.shopsPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
        />
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopShopsListPanel from "@/entities/dictionaries/shops/panels/TopShopsListPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import ShopsTable from "@/entities/dictionaries/shops/ShopsTable.vue";
import ShopsFilterForm from "@/entities/dictionaries/shops/forms/ShopsFilterForm.vue";

import { useShopsStore, ShopsParams } from "@/store/dictionaries/shops";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import { setShopsParamsByFilter } from "@/services/dictionaries/shops";
import { FilterForm } from "@/services/dictionaries/shops";

const store = useShopsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const filteredShops = computed(() => {
  return store.shopsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateShopsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateShopsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateShopsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateShopsList();
};

const updateShopsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: ShopsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setShopsParamsByFilter(params, tableDisplaySettings.value);

  store.getShops(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateShopsList, 200);
});
</script>
